export default (input, delimiters = [',', ';', '.', ' ', '\t', '\n']) => {
  if (!input) return [];

  const inputValue = Array.isArray(input) ? input.join(',') : String(input);

  const parts = inputValue.split(new RegExp(`[${delimiters.join('')}]`));

  return [...new Set(parts.filter((part) => part.trim() !== ''))];
};
